class ProductAtcPrice extends HTMLElement {
  constructor() {
    super();
    this.update = this.update.bind(this);
  }

  connectedCallback() {
    this.root = this.closest('product-info');
    if (!this.root) return;

    this.root.addEventListener('change', this.update);
    this.root.addEventListener('click', this.update);
    this.update();
  }

  disconnectedCallback() {
    this.root?.removeEventListener('change', this.update);
    this.root?.removeEventListener('click', this.update);
  }

  get output() {
    return this.querySelector('[data-atc-price]');
  }

  get quantity() {
    const input = this.root.querySelector('input[name="quantity"]');
    const value = parseInt(input?.value, 10);
    return Number.isNaN(value) || value < 1 ? 1 : value;
  }

  /* Purchase option radios carry the selling plan allocation price, which
     overrides the variant price rendered into the button server-side. */
  get unitPrice() {
    const selected = this.root.querySelector('.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) input[type="radio"]:checked');
    const planPrice = parseInt(selected?.dataset.unitPrice, 10);
    if (!Number.isNaN(planPrice)) return planPrice;

    const variantPrice = parseInt(this.dataset.unitPrice, 10);
    return Number.isNaN(variantPrice) ? null : variantPrice;
  }

  format(cents) {
    const currency = this.dataset.currency;
    if (!currency) return null;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
      }).format(cents / 100);
    } catch (error) {
      return null;
    }
  }

  update() {
    const output = this.output;
    if (!output) return;

    const unitPrice = this.unitPrice;
    if (unitPrice === null) return;

    // The quantity input fires change after the stepper buttons mutate it, so
    // reading on the next frame keeps both paths in sync.
    requestAnimationFrame(() => {
      const formatted = this.format(unitPrice * this.quantity);
      if (formatted) output.textContent = formatted;
    });
  }
}

if (!customElements.get('product-atc-price')) {
  customElements.define('product-atc-price', ProductAtcPrice);
}
